import { createContext } from "react";
import stores from "./stores";

export const StoreContext = createContext(stores);
export const StoreProvider = StoreContext.Provider;
